<template>
    <div>
        <a-image :width="width" :height="height ? height : width" :src="_src" :preview="preview" :fallback="fallback" />
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            default: ''
        },
        width: {
            type: [Number, String],
            default: 60
        },
        height: {
            type: [Number, String],
            default: ''
        },
        fallback: {
            type: String,
            default: require('@/assets/images/public/default_img.png')
        },
        preview: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        _src() {
            if (this.src) {
                return this.src
            }
            return this.fallback
        }
    }
}
</script>

<style></style>